import React from 'react';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import IconButton from '@starbucks-web/pattern-library/lib/components/icon-button/';
import infoPath from '@starbucks-web/pattern-library/lib/icons/info';
import Tooltip from '@starbucks-web/pattern-library/lib/components/tooltip';

import messages from './messages';
import { sharedCallsToAction } from 'shared/app/messages/ctas';

/* A note on positioning...
 * The info IconButton displaces 44px of vertical space, which throws off top and bottom
 * padding of its parent. Instead of using negative margin to offset the unexpected height,
 * this opts to make the tooltip the child of an absolutely positioned span, which takes up no
 * height in the rendered page.
 */
const CaloriesDisclaimerTooltip = ({
  innerClassName,
  intl: { formatMessage },
  iconClassName,
}) => (
  <span className="relative">
    <span className={classNames('absolute', innerClassName)}>
      <Tooltip
        bodyText={formatMessage(messages.caloriesDisclaimer)}
        closeButtonAriaLabel={formatMessage(sharedCallsToAction.closeLabel)}
        tooltipClassName="text-left"
      >
        <IconButton
          ariaLabel={formatMessage(messages.caloriesDisclaimerAriaLabel)}
          className={`color-textWhiteSoft ${iconClassName ?? ''}`}
          path={infoPath}
          size="16px"
        />
      </Tooltip>
    </span>
  </span>
);

export default injectIntl(CaloriesDisclaimerTooltip);
